function dropdownMenu() {
    if ($(window).width() < 1410) {
        $(document).ready(function() {
            console.log("running");
            
            // Remove href attribute from dropdown toggles
            $('[data-toggle="dropdown"]').removeAttr('href');
            
            $('[data-toggle="dropdown"]').click(function(e) {
                e.preventDefault();

                $(this).siblings('.dropdown-content').toggleClass('show');

                $('[data-toggle="dropdown"]').not(this).siblings('.dropdown-content').removeClass('show');
            });
        });
    }
}

export default dropdownMenu;
